<template>
  <div v-if="fiMonthlyReport">
    <a-descriptions
      title="Financial institution Info"
      layout="vertical"
      :column="2"
      bordered
    >
      <a-descriptions-item label="ShareValue">
        <span v-if="fiMonthlyReport.shareValue">
          {{ fiMonthlyReport.shareValue.amount | formatMoney }}
          {{ fiMonthlyReport.shareValue.currency }}
        </span>
        <span v-else>
          -
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="Dividend">
        <span v-if="fiMonthlyReport.dividend">
          {{ fiMonthlyReport.dividend.amount | formatMoney }}
          {{ fiMonthlyReport.dividend.currency }}
        </span>
        <span v-else>
          -
        </span>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  apollo: {
    fiMonthlyReport: {
      query: gql`
        query GetFIMonthlyReport(
          $institutionId: Uuid!
          $year: Int!
          $month: Int!
        ) {
          fiMonthlyReport(
            institutionId: $institutionId
            year: $year
            month: $month
          ) {
            shareValue {
              amount
              currency
            }
            dividend {
              amount
              currency
            }
          }
        }
      `,
      variables() {
        return {
          institutionId: this.report.institutionId,
          year: this.report.year,
          month: this.report.month,
        }
      },
    },
  },
  data() {
    return {
      fiMonthlyReport: null,
    }
  },
}
</script>

<style></style>
